module.exports = __webpack_public_path__ + "img/中国报道新闻网_02.26a07a3b.jpg";